export const GAME_NAME: string = "XavierStoryCreator";
const PREFIX: string = GAME_NAME + ".";

export const PLAY_CAPTION: string = "PlayCaption";
export const STOP_CAPTION: string = "StopCaption";

export const GAME_PAUSED: string = PREFIX + "Paused";
export const GAME_UNPAUSED: string = PREFIX + "UnPaused";
